export default __webpack_public_path__ + "static/media/export.c47875b5.svg";